const loginPanels = {
    LOGIN: 1,
    ACCESS_REQUEST: 2,
    RESET_PASSWORD: 3
}

export {
    loginPanels
}